import * as React from 'react'
import { SideDrawer } from '@sales-center/components'
import { ENTITY_TYPES } from '@sales-center/common'
import { ReOrderServicesForm } from './ReOrderServicesForm/ReOrderServicesForm'
import { ILeadOppProduct } from '@user/store/leadOppProducts'

interface Props {
  onClose: () => void
  open: boolean
  services: ILeadOppProduct[]
  entityType: ENTITY_TYPES
}

export function ReOrderServicesDrawer(props: Props) {
  const { onClose, open, services, entityType } = props
  return (
    <SideDrawer
      title=" Re-Order Services"
      onClose={onClose}
      open={open}
      width={550}
    >
      <ReOrderServicesForm
        services={services}
        onClose={onClose}
        entityType={entityType}
      ></ReOrderServicesForm>
    </SideDrawer>
  )
}
